
import {defineComponent, ref} from 'vue'
import recherchevehicule from "@/services/recherche_page.services";

export default defineComponent({
  name: 'checkBox',
  isChecked: Boolean,
  props: {
    id: String,
    group: String,
    name: String,
    total: Number,
    value: String
  },
  data () {
    return {
      isChecked: Boolean(this.isChecked || false)
    }
  },
  methods: {
    toggleClass: function () {
      this.isChecked = !this.isChecked;
    },
    toUpperCase: function(value: string) {
      const words = value.split(' ').map(word => {
        if (word.includes('-')) {
          return word.split('-').map(part => part.charAt(0).toUpperCase() + part.slice(1)).join('-');
        } else {
          return word.charAt(0).toUpperCase() + word.slice(1);
        }
      });
      return words.join(' ');
    }
  },
  mounted() {
    // Initialisation de la sélection
    this.isChecked = recherchevehicule.isChecked(this.group, this.value);
  }
})
